import { render, staticRenderFns } from "./BlockType14List.vue?vue&type=template&id=cdef656a&scoped=true"
import script from "./BlockType14List.vue?vue&type=script&lang=ts"
export * from "./BlockType14List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType14List.vue?vue&type=style&index=0&id=cdef656a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdef656a",
  null
  
)

export default component.exports